export function marketingPaths(url: string): string {
  return `https://spoutstudio.web.app/${url}`;
}
